import React, { useRef, useEffect } from "react";
// import ImageModal from "../Modal/ImageModal";

function ExpandableImage(props) {
  const { url, imgClassName = "" } = props;
  const imgRef = useRef();
  // const [isModalOpen, setModal] = useState(false);
  // const toggleModal = () => setModal((prev) => !prev);
  const openInNewTab = (url) => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };
  useEffect(() => {
    if (!imgRef?.current) return;

    imgRef.current.clientHeight = 20;
    imgRef.current.clientWidth += 20;

    return () => (imgRef.current = null);
  }, []);

  return (
    <div style={{ width: "100%", position: "sticky", top: "100px" }}>
      <img
        src={url}
        className={imgClassName}
        alt=""
        onClick={() => openInNewTab(url)}
        style={{ cursor: "pointer" }}
      />
      {/* <ImageModal show={isModalOpen} onHide={toggleModal} fullscreen={false}>
        <img
          src={url}
          className={imgClassName}
          style={{
            height: imgRef?.current?.clientHeight,
            width: imgRef?.current?.clientWidth,
          }}
          alt=""
          ref={(ref) => (imgRef.current = ref)}
        />
      </ImageModal> */}
    </div>
  );
}

export default ExpandableImage;
